import { REDUCER_NAME } from './constants.js'

const contractData = (state) => {
  return state[REDUCER_NAME].data
}

const contractFormData = (state) => {
  return state[REDUCER_NAME].formData
}

const isLoadingContractData = (state) => {
  return state[REDUCER_NAME].isLoading
}

const isSavingContractData = (state) => {
  return state[REDUCER_NAME].isSaving
}

export {
  contractData,
  contractFormData,
  isLoadingContractData,
  isSavingContractData
}
